import { Button, Group, Stack, Text, ThemeIcon } from "@mantine/core";
import { useLanguage } from "../../../../stores/LanguageStore";
import { IconCheck } from "@tabler/icons-react";

const UAFinish = ({ setIsLocked }) => {
  const lang = useLanguage((s) => s.language);
  return (
    <Stack>
      <Group>
        <ThemeIcon
          variant="light"
          color="green.8"
          size={48}
          radius={"xl"}
        >
          <IconCheck />
        </ThemeIcon>
      <Text fz={24} fw={600}>
        {lang.unlock_account.step_finish.success}
      </Text>
      </Group>
      <Text my={8} size="lg">
        {lang.unlock_account.step_finish.text}
      </Text>

      <Button onClick={() => setIsLocked(false)} size="lg">
        {lang.unlock_account.step_finish.button_label}
      </Button>
    </Stack>
  );
};

export default UAFinish;
